module.exports = __webpack_public_path__ + "img/issue_3.1f8e9c1e.png";